import React, { useEffect } from "react";
import SwipeableBottomSheet from "react-swipeable-bottom-sheet";

const BottomSheet = ({
  isOpen,
  setClose,
  setCloseCustom,
  className,
  classNames,
  viewerClassName,
  children,
  ...props
}) => {
  useEffect(() => {
    let container = document.getElementsByClassName(
      `bottom-sheet-holder popup-open`
    );
    if (container && container[0]) {
      container = container[0];
    } else {
      container = document;
    }

    const ReactSwipeable = container.getElementsByClassName(
      `react-swipeable-view-container`
    );

    if (ReactSwipeable && ReactSwipeable[0] && ReactSwipeable[0].classList) {
      ReactSwipeable[0].classList.add(className || null);
    }
  });

  return (
    <>
      <SwipeableBottomSheet
        open={isOpen}
        overflowHeight={0}
        onChange={(state) => {
          if (state === false) {
            if (setClose) {
              setClose(false);
            }
            if (setCloseCustom) {
              setCloseCustom();
            }
          }
        }}
        style={{ zIndex: 99, background: "transparent" }}
        swipeableViewsProps={{
          className: `unselectable bottom-sheet-holder ${
            isOpen ? "popup-open" : ""
          } ${classNames ? classNames : ""}`,
        }}
        {...props}
      >
        <div
          className={`bottom-sheet-viewer unselectable ${
            viewerClassName ? viewerClassName : ""
          }`}
        >
          {children && children}
        </div>
      </SwipeableBottomSheet>
    </>
  );
};

export default BottomSheet;
